import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
    state: () => ({
        userData: null,
        accessCodeResponse: null,
        email: null
    }),
    
    actions: {
        setAccessCodeResponse(email, accountType, accessCode, flags) {
            this.accessCodeResponse = { email, accountType, accessCode, flags };
        },
        
        setUserData(data) {
            this.userData = data;
        },
        
        clearUserData() {
            this.userData = null;
            this.accessCodeResponse = null;
        },

        setEmail(email) {
            this.email = email;
        }
    },
    
    getters: {
        getAccessCodeResponse: (state) => state.accessCodeResponse,
        getUserData: (state) => state.userData,
        getEmail: (state) => state.email
    }
}); 